import mammoth from "mammoth";
import { toStyleMap } from "./stylemap.js";

export const inlineImages = mammoth.images.imgElement((image) =>
  image.read("base64").then((data) => ({ src: `data:${image.contentType};base64,${data}` })));

// mammoth's Node build reads `buffer`, its browser build reads `arrayBuffer`.
export async function convert(data, profile) {
  const result = await mammoth.convertToHtml(
    { arrayBuffer: data, buffer: data },
    { styleMap: toStyleMap(profile), convertImage: inlineImages },
  );
  return { html: result.value, messages: result.messages };
}
